var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoInventoryActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.7568,
    y: 15.25,
    width: 3.20625,
    height: 3.20625,
    rx: 0.5,
    transform: "rotate(90 12.7568 15.25)",
    fill: "#1877F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5571,
    y: 15.25,
    width: 3.20625,
    height: 3.20625,
    rx: 0.5,
    transform: "rotate(90 16.5571 15.25)",
    fill: "#1877F5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.95752,
    y: 11.569,
    width: 3.20625,
    height: 3.20625,
    rx: 0.5,
    transform: "rotate(90 8.95752 11.569)",
    fill: "#1877F5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7568,
    y: 11.45,
    width: 3.20625,
    height: 3.20625,
    rx: 0.5,
    transform: "rotate(90 12.7568 11.45)",
    fill: "#1877F5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.95752,
    y: 15.25,
    width: 3.20625,
    height: 3.20625,
    rx: 0.5,
    transform: "rotate(90 8.95752 15.25)",
    fill: "#1877F5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.95752,
    y: 7.65,
    width: 3.20625,
    height: 3.20625,
    rx: 0.5,
    transform: "rotate(90 8.95752 7.65)",
    fill: "#1877F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3414 8.84507L11.216 1.21817C11.0848 1.07778 10.9139 0.999993 10.7366 1C10.5594 1.00001 10.3885 1.07781 10.2573 1.21821L3.13283 8.84508C3.05939 8.9237 3.00071 9.01953 2.96055 9.12641C2.9204 9.23329 2.89966 9.34887 2.89966 9.46574V19.1611C2.89966 19.3836 2.97473 19.597 3.10834 19.7543C3.24196 19.9116 3.42319 20 3.61216 20H17.8622C18.0511 20 18.2324 19.9116 18.366 19.7543C18.4996 19.597 18.5747 19.3836 18.5747 19.1611V9.46578C18.5747 9.3489 18.5539 9.23331 18.5138 9.12642C18.4736 9.01953 18.4149 8.9237 18.3414 8.84507Z",
    stroke: "#1877F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8348 7.87519L18.1327 7.16316L16.7086 8.56745L17.4108 9.27949L18.8348 7.87519ZM19.7406 11.6421C20.1284 12.0354 20.7616 12.0398 21.1548 11.652C21.548 11.2642 21.5525 10.6311 21.1647 10.2378L19.7406 11.6421ZM17.4108 9.27949L19.7406 11.6421L21.1647 10.2378L18.8348 7.87519L17.4108 9.27949Z",
    fill: "#1877F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.292893 10.2392C-0.0976311 10.6297 -0.0976311 11.2629 0.292893 11.6534C0.683418 12.0439 1.31658 12.0439 1.70711 11.6534L0.292893 10.2392ZM4.05342 9.3071L4.76052 8.59999L3.34631 7.18578L2.6392 7.89288L4.05342 9.3071ZM1.70711 11.6534L4.05342 9.3071L2.6392 7.89288L0.292893 10.2392L1.70711 11.6534Z",
    fill: "#1877F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInventoryActive);
export default __webpack_public_path__ + "static/media/ico-inventory-active.021a1519782687b29e8578855cd875ea.svg";
export { ForwardRef as ReactComponent };